export default __webpack_public_path__ + "static/media/vol4Issue3.bd6ecba6.png";